import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ScreenSize, ToasterState } from '@lyceo/shared/util-models';

export const ApplicationActions = createActionGroup({
  source: 'Application',
  events: {
    'Init': emptyProps(),
    'Screen size changed': props<{ screenSize: ScreenSize }>(),
    'Show Toaster': props<{ toaster: ToasterState }>(),
    'Guards Check Start': emptyProps(),
    'Guards Check End': emptyProps(),
  },
});
